import styled, { css } from 'styled-components';
import { media } from '@minecraft.themes';

export const XsmPageWrapperStyles = css`
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const SmPageWrapperStyles = css`
  ${media.sm`
    padding-left: 1.125rem;
    padding-right: 1.125rem;
  `}
`;

export const MdPageWrapperStyles = css`
  ${media.md`
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  `}
`;

export const LgPageWrapperStyles = css`
  ${media.lg`
    padding-left: 1rem;
    padding-right: 1rem;
  `}
`;

export const XlgPageWrapperStyles = css`
  ${media.xlg`
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  `}
`;

export const PageWrapperStyles = css`
  ${XsmPageWrapperStyles}
  ${SmPageWrapperStyles}
  ${MdPageWrapperStyles}
  ${LgPageWrapperStyles}
  ${XlgPageWrapperStyles}
`;

const PageWrapper = styled.div`
  ${PageWrapperStyles}
`;

export default PageWrapper;
